import { t } from 'ttag';

import { ENV, ENV_ENUM } from './env';

const SELECTED_PORTAL = 'Clinic';

const BIOTRES_OFFLINE_WARNING_MESSAGE = t`Device has been offline for more than 2 hours. Please ensure a continuous device-to-app connection for real-time notifications and study reliability.`;

const EVENT_PRIORITY_DROPDOWN_OPTIONS = [t`Low`, t`Medium`, t`High`, t`Urgent`, t`Emergent`];

const FULL_EVENT_TYPE_OPTIONS = ['Brady', 'Tachy', 'AFib', 'Pause', 'Auto', 'Sinus'];

const PATIENT_SYMPTOMS_OPTIONS = [
  {
    label: 'TIA',
    value: 'TIA',
  },
  {
    label: 'Chest pain',
    value: 'Chest pain',
  },
  {
    label: 'Shortness of breath',
    value: 'Shortness of breath',
  },
  {
    label: 'Irregular heartbeat',
    value: 'Irregular heartbeat',
  },
  {
    label: 'Palpitations',
    value: 'Palpitations',
  },
  {
    label: 'Dizziness',
    value: 'Dizziness',
  },
  {
    label: 'Feeling faint',
    value: 'Feeling faint',
  },
  {
    label: 'Collapsed',
    value: 'Collapsed',
  },
  {
    label: 'Feeling clammy/sweaty',
    value: 'Feeling clammy/sweaty',
  },
];

const FREQUENTLY_OF_SYMPTOMS_OPTIONS = [
  {
    label: 'Less than 6',
    value: 'Less than 6',
  },
  {
    label: 'From 6 to 12',
    value: 'From 6 to 12',
  },
  {
    label: 'More than 12',
    value: 'More than 12',
  },
];

const USED_HEART_MONITOR_OPTIONS = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

const GENDER_OPTIONS = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
];

const INSURANCE_TYPE_OPTIONS = [
  {
    label: 'Medicare',
    value: 'Medicare',
  },
  {
    label: 'Private',
    value: 'Private',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

const PRE_AUTHORIZATION_OPTIONS = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

const STATUS_REPORT_OPTIONS = [
  {
    label: 'New',
    value: 'New',
  },
  {
    label: 'Downloaded',
    value: 'Downloaded',
  },
  {
    label: 'Reviewed',
    value: 'Reviewed',
  },
  {
    label: 'Interpreted',
    value: 'Interpreted',
  },
  {
    label: 'Signed',
    value: 'Signed',
  },
  {
    label: 'Completed',
    value: 'Completed',
  },
];

const STATUS_REPORT = {
  NEW: 'New',
  DOWNLOADED: 'Downloaded',
  REVIEWED: 'Reviewed',
  INTERPRETED: 'Interpreted',
  SIGNED: 'Signed',
  COMPLETED: 'Completed',
};

const EMITTER_CONSTANTS = {
  STUDY_DELETED: 'STUDY_DELETED',
  LAST_SYNC: 'LAST_SYNC',
  DEVICE_EVENT: 'DEVICE_EVENT',
  STUDY_EVENT: 'STUDY_EVENT',
  ECG_UPLOAD_PROCESS: 'ECG_UPLOAD_PROCESS',
  UPDATE_TOTAL_EVENTS: 'UPDATE_TOTAL_EVENTS',
  UPDATE_EVENT_ECG: 'UPDATE_EVENT_ECG',
  STUDY_UPDATED_EVENT: 'STUDY_UPDATED_EVENT',
  EVENT_ROOM_USER: 'EVENT_ROOM_USER',
  REPORT_UPDATED: 'REPORT_UPDATED',
  EVENT_UPDATED: 'EVENT_UPDATED',
  INBOX_EVENTS: 'INBOX_EVENTS',
  MARK_INBOX_EVENT: 'MARK_INBOX_EVENT',
  MARK_STATUS_REPORT: 'MARK_STATUS_REPORT',
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
  NEW_EVALUATION_STRIP: 'NEW_EVALUATION_STRIP',
  UPDATE_NEW_EVENT_ECG: 'UPDATE_NEW_EVENT_ECG',
  BIODIRECT_EVENT: 'BIODIRECT_EVENT',
  SHOW_POPUP_ESCALATION: 'SHOW_POPUP_ESCALATION',
  SHOW_POPUP_C1C_REPORT: 'SHOW_POPUP_C1C_REPORT',
  ARTIFACT_STUDIES_UPDATED: 'ARTIFACT_STUDIES_UPDATED',
  NOTIFICATION: 'NOTIFICATION',

  IS_SHOW_LOGIN_BY_BANNER: 'IS_SHOW_LOGIN_BY_BANNER',

  // *: Email
  USER_UPDATED: 'USER_UPDATED',

  // *: Webview for create study page
  UPDATE_TOKEN_LOCAL_STORAGE: 'UPDATE_TOKEN_LOCAL_STORAGE',

  // *: RMA
  RMA_TICKET_UPDATED: 'RMA_TICKET_UPDATED',
  RMA_TICKET_CREATED: 'RMA_TICKET_CREATED',

  // *: Program subscribe/unsubscribe (Protect+ / Renewal stock)
  PROGRAMS_UPDATED: 'PROGRAMS_UPDATED',

  // *: Facility setting (canViewFlaggedStudies)
  FACILITY_SETTING_UPDATED: 'FACILITY_SETTING_UPDATED',
  FACILITY_CHANGED: 'FACILITY_CHANGED',
  STUDY_PRICING_UPDATED: 'STUDY_PRICING_UPDATED',

  DEVICE_STARTED_STUDY: 'DEVICE_STARTED_STUDY',
  SEND_DEVICE_CONNECTION_STATUS: 'SEND_DEVICE_CONNECTION_STATUS',
  DISPLAY_WHAT_IS_NEW_MODAL: 'DISPLAY_WHAT_IS_NEW_MODAL',
  UPLOAD_STATUS: 'UPLOAD_STATUS',
  INSTANT_REPORT_UPDATED: 'INSTANT_REPORT_UPDATED',
  SITE_UNDER_MAINTENANCE: 'SITE_UNDER_MAINTENANCE',
  SITE_UNAUTHORIZED: 'SITE_UNAUTHORIZED',
  ACCESS_REMOVED: 'ACCESS_REMOVED',
  EXTEND_ACTIVE_SESSION: 'EXTEND_ACTIVE_SESSION',
  SOCKET_CONNECTION_ERROR: 'SOCKET_CONNECTION_ERROR',
  MAINTENANCE_CHANGED: 'MAINTENANCE_CHANGED',
  ADD_SIGNATURE_TIME_TRACKING: 'ADD_SIGNATURE_TIME_TRACKING',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED',
  SOCKET_RECONNECTED: 'SOCKET_RECONNECTED',
};

const STREAMING_EMITTER_CONSTANTS = {
  WEBSOCKET_CONNECTED: 'WEBSOCKET_CONNECTED',
  WEBSOCKET_CLOSE: 'WEBSOCKET_CLOSE',
  WEBSOCKET_ERROR: 'WEBSOCKET_ERROR',
  ON_MESSAGE_DATA: 'ON_MESSAGE_DATA',
  ON_ROOM_CHANGED: 'ON_ROOM_CHANGED',
  PAUSE_WORKING_STATUS: 'PAUSE_WORKING_STATUS',
};

const ARTIFACT_REPORT_HOVER_TEXT = 'Report is marked as artifact';

const REPORT_REVIEWED_HOVER_TEXT = 'Report reviewed';

const MESSAGE_ARTIFACT_REPORT =
  'This report could not be generated due to all data being artifact. Please ensure you are checking ECG connection when starting a study';

const DEVICE = {
  BIOFLUX: 'Bioflux',
  BIOTRES: 'Biotres',
  BIOTRES_PRO: 'Biotres Pro',
  BIOTRESRT: 'BiotresRT',
  BIOTRESRTL: 'BiotresRTL',
  BIOCORE: 'Biocore',
  BIOCORE_PRO: 'Biocore Pro',
  ICOR: 'iCOR',
};

const C1C_DEVICE_TYPES = ['LifeSignals', 'VivaLNK'] as const;

const DESCRIPTION_ENUM = {
  DAMAGE: 'DAMAGED DESCRIBE',
  OTHER: 'OTHER DESCRIBE',
  DEVICE_ERROR_CONFIRMED: 'Device Error Confirmed (describe)',
  DAMAGE_CONFIRMED: 'Damage Confirmed (describe)',
  REPAIR_OTHER: 'Repair - Other',
  DEVICE_ERRORS: 'DEVICE ERRORS DESCRIBE',
};

const DEVICE_TABLE_TYPE = {
  IN_STUDY: 'In Study',
  AWAITING_UPLOAD: 'Awaiting upload',
  NOT_IN_STUDY: 'Not in study',
  RMA: 'RMA',
  ALL: 'All devices',
  LOST_INACTIVE: 'Lost/Inactive',
  UNUSED: 'Unused',
  END_OF_LIFE: 'End of life',
  ALL_DEVICES: 'All devices',
  UNUSED_ALL: 'Unused All',
  UNUSED_ONEMONTH: 'Unused One Month',
  UNUSED_TWOMONTH: 'Unused Two Month',
  UNUSED_THREEMONTH: 'Unused Three Month',
  UNUSED_SIXMONTH: 'Unused Six Month',
  UNUSED_ONEYEAR: 'Unused One Year',
  MAINTENANCE: 'Maintenance',
  ALL_DEVICES_TAB: 'allDevicesTab',
  UNUSED_DEVICES_TAB: 'unusedDevicesTab',
};

const PROGRAMS = {
  PROTECT_PLUS: 'ProtectPlus',
  RENEWAL_STOCK: 'RenewalStock',
};

const ERROR_ACTION = {
  REDIRECT: 'redirect',
  LOGOUT: 'logout',
  CHANGE_ROLE: 'changeRole',
  LOGOUT_USERNAME: 'LOGOUT_USERNAME',
};

const SUPPORT_REQUEST_STATUS_ENUM = {
  New: 'New',
  Done: 'Done',
};

const { New, Done } = SUPPORT_REQUEST_STATUS_ENUM;

const SUPPORT_REQUEST_STATUS = {
  [New]: 'Open',
  [Done]: 'Resolved',
};

const SUPPORT_REQUEST_ACTION = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  REOPEN: 'Re-open',
  COMMENT: 'Comment',
};

const SUPPORT_REQUEST_ACTION_CONTENT = {
  CLOSED: t`resolved this support request`,
  REOPEN: t`re-opened this support request`,
  CLOSED_BY_EMAIL: t`The ticket has been resolved through email`,
};

const INVALID_EMAIL_ERROR_MESSAGE = t`The field contains email(s) with invalid format, please check again!`;

const VERSION_CAN_RUN_MCT = 1008809;

const SUPPORT_URL_REQUEST_TYPE = {
  changeStudyType: 'change-study-type',
  abortStudy: 'abort-study',
  reportRequest: 'report-request',
  webPortalIssues: 'web-portal-issues',
  billingQuestions: 'billing-questions',
  others: 'others',
  changeStudyInformation: 'change-study-information',
};

const FACILITY_PROGRAMS = {
  RETURN_TO_STOCK: 'RETURN_TO_STOCK',
};

const OTHER_RMA_REASONS = {
  LOST_DEVICE: 'LOST DEVICE',
  RETURN_TO_STOCK: 'RETURN TO STOCK',
  CLOSED_ACCOUNT: 'CLOSED ACCOUNT',
  DEVICE_RETURNED_WITHOUT_RMA: 'DEVICE RETURNED WITHOUT RMA',
};

const PATIENT_IMPACT = {
  NONE: 'NONE',
};

const PROGRAM_REASON = {
  PROTECT_PLUS: 'PROTECT+ PROGRAM',
  RETURN_FOR_MAINTENANCE: 'RETURN FOR MAINTENANCE',
};

const SIGNATURE_ENUM = {
  STANDARD: 'STANDARD',
  ADULT: 'ADULT',
};

const DOUBLE_HYPHEN_BULLET = '⁃⁃';

const HIGH_SAMPLING_RATE_SCHEMA = '01018813';

const UPLOAD_STATUS = {
  UPLOADED: 'Uploaded',
  UPLOADING: 'Uploading',
  WAITING: 'Waiting',
};

const BIOTRICITY_ADDRESS = {
  name: 'Biotricity Service Center',
  street1: '203 Redwood Shores PKWY STE, 600',
  state: 'CA',
  city: 'Redwood City',
  country: 'US',
  zip: '94065',
  phone: '800-590-4155',
  email: 'service@biotricity.com',
};

const SHOULD_HIDE_INSTANT_REPORT_ORGANIZATION_IDS =
  ENV === ENV_ENUM.staging
    ? [
        '69b7c59679989e4a941f5130', // 2020 Diagnostics Group
      ]
    : ENV === ENV_ENUM.customer
      ? [
          '69b7c49de77339861e488f69', // 2020 Diagnostics Group
        ]
      : [];

const SHOULD_HIDE_INSTANT_REPORT_FACILITY_IDS =
  ENV === ENV_ENUM.staging
    ? [
        '67612842f716b9676a1c3fa5', // CP-2.28.0 (Disable Instant) - 1002423
        '654b4c68df8dcebc5aa48588', // CP2.22.2 (Disable Instant) - 1001996
      ]
    : ENV === ENV_ENUM.customer
      ? [
          '65aff3c5b2694238327ba40e', // Vital Heart and Vein Sugar Land - 1004915
          '65286aeb0bee1ca37ad5c291', // Vital Heart and Vein Southeast Houston - 1004649
          '64781c1de98f512e09fb2f11', // Vital Heart and Vein West Houston - 1004460
          '63d90f1d5ab2501eff16759c', // Vital Heart and Vein Northwest - 1004068
          '62a92cc22fdbc9eff7fdb106', // Vital Heart and Vein Texas Medical Center - 1003256
          '62a92ab82fdbc935f1fdb0ff', // Vital Heart and Vein Pearland - 1003249
          '5f33b3a28ea3572114d1251a', // Vital Heart and Vein Humble - 1001065
          '5edad68186e2a5364a3ab7bb', // Manhattan Cardiology - 1000897
          '5fec6b735e206fe0635a6c88', // Advanced Cardiovascular Institute - 1001555
          '66bbf0a6819d384ebd16d1b9', // Connected Cardiovascular Care Associates - 1005363
          '6786e101fd43f5ca5fd67e0e', // Heart and Vascular Care - Canton, CVAUSA - 1005615
          '6786dc26fd43f5ca5fd67c76', // Heart and Vascular Care - Cumming, CVAUSA - 1005608
          '684c5ae7cd18ae8d014b0b6b', // Village Heart and Vein, CVAUSA - 1005937
          '6930534e4182476b985bd239', // New York Comprehensive Medical Care - Bohemia - 1006812
          '693052cd4182476b985bd203', // New York Comprehensive Medical Care - Smithtown - 1006805
          '6984f35029d75eebc1206377', // 2020 Diagnostics - 1007190
          '69a87fbc26f924cb6a88bb33', // Michael Aziz Medical - 1007288
          '69b228b5a7ab544532e7d5bf', // Atlantic Cardiovascular Care PC - 1007337
          '69b22bb5a7ab544532e7d779', // Kelin Medical - 1007344
          '69b22e01a7ab544532e7d85a', // Comprehensive Cardiac Care Center - 1007351
          '69b22f58a7ab544532e7d92d', // Toreli Cardiology - 1007358
          '69b23489a7ab544532e7db5b', // Southern Westchester Medical PC - 1007365
          '69b240eca7ab544532e7df68', // Sunshine Cardiology - 1007372
          '69b2ddf7a7ab544532e83eee', // University Physicians of Brooklyn - 1007379
          '69b38646a7ab544532e8a650', // Adam S. Budzikowski, ACE - 1007386
          '69b38b82a7ab544532e8a894', // Adam S. Budzikowski - 1007393
          '69b38f1da7ab544532e8a999', // Adam S. Budzikowski, NMT - 1007400
          '69b3e1bda7ab544532e8cf84', // Caribbean Electrophysiology Services - 1007414
          '69b7bc6fa7ab544532ea4d80', // Test 2020 Diagnostics Group Migrate - 1007449
          '69b7c904a7ab544532ea52cd', // Test 2020 Diagnostics Group - 1007456
          '689131f78509e099d2fd7bbf', // Prima Care PC - 1006091
          '5f74cca19b3a00586d4f60c4', // Lone Star Heart & Vascular Clinic PA - 1001296
        ]
      : [];

const BIOTRICITY_SUPPORT_ADDRESS = {
  phone: '800-590-4155',
  email: 'service@biotricity.com',
  csMail: 'cs@biotricity.com',
  billingMail: 'billing@biotricity.com',
};

const HEART_SMART_SUPPORT_ADDRESS = {
  email: 'support@heartsmartInc.com',
};

const ORGANIZATION_SLUG = {
  MERCY: 'mercy',
  GENERAL: 'general',
  CARDIOLOGX: 'cardiologx',
  VITAL_HEART: 'vital-heart',
  CARDIO_ONE: 'cardio-one',
  HEART_SMART: 'heart-smart',
  GRUPO_CARDIOLOGICO_BOSKIS: 'grupo-cardiologico-boskis',
};

const HAS_LOGIN_BANNER_ORGANIZATION_SLUGS = [
  ORGANIZATION_SLUG.CARDIOLOGX,
  ORGANIZATION_SLUG.CARDIO_ONE,
  ORGANIZATION_SLUG.GRUPO_CARDIOLOGICO_BOSKIS,
];

const INTERGRATION_ORG = {
  CARDIO_ONE: 'CardioOne',
};

const CLIENT_NAMES = ['clinic-portal-desktop', 'clinic-portal-mobile'];

export {
  ARTIFACT_REPORT_HOVER_TEXT,
  BIOTRES_OFFLINE_WARNING_MESSAGE,
  BIOTRICITY_ADDRESS,
  BIOTRICITY_SUPPORT_ADDRESS,
  CLIENT_NAMES,
  DESCRIPTION_ENUM,
  C1C_DEVICE_TYPES,
  DEVICE,
  DEVICE_TABLE_TYPE,
  DOUBLE_HYPHEN_BULLET,
  EMITTER_CONSTANTS,
  ERROR_ACTION,
  EVENT_PRIORITY_DROPDOWN_OPTIONS,
  FACILITY_PROGRAMS,
  FREQUENTLY_OF_SYMPTOMS_OPTIONS,
  FULL_EVENT_TYPE_OPTIONS,
  GENDER_OPTIONS,
  HEART_SMART_SUPPORT_ADDRESS,
  HIGH_SAMPLING_RATE_SCHEMA,
  INSURANCE_TYPE_OPTIONS,
  INVALID_EMAIL_ERROR_MESSAGE,
  MESSAGE_ARTIFACT_REPORT,
  ORGANIZATION_SLUG,
  OTHER_RMA_REASONS,
  PATIENT_IMPACT,
  PATIENT_SYMPTOMS_OPTIONS,
  PRE_AUTHORIZATION_OPTIONS,
  PROGRAM_REASON,
  PROGRAMS,
  REPORT_REVIEWED_HOVER_TEXT,
  SELECTED_PORTAL,
  SHOULD_HIDE_INSTANT_REPORT_FACILITY_IDS,
  SHOULD_HIDE_INSTANT_REPORT_ORGANIZATION_IDS,
  SIGNATURE_ENUM,
  STATUS_REPORT,
  STATUS_REPORT_OPTIONS,
  STREAMING_EMITTER_CONSTANTS,
  SUPPORT_REQUEST_ACTION,
  SUPPORT_REQUEST_ACTION_CONTENT,
  SUPPORT_REQUEST_STATUS,
  SUPPORT_REQUEST_STATUS_ENUM,
  SUPPORT_URL_REQUEST_TYPE,
  UPLOAD_STATUS,
  USED_HEART_MONITOR_OPTIONS,
  VERSION_CAN_RUN_MCT,
  INTERGRATION_ORG,
  HAS_LOGIN_BANNER_ORGANIZATION_SLUGS,
};
